/**
 * The client an internal user is viewing on behalf of, carried as `?client=<tenantId>` so a
 * reload, a redirect or a picked audience keeps it. Client users never carry one.
 */
export const CLIENT_PARAM = 'client';

/** A path with the client carried on it, when there is one. */
export const withClient = (path: string, tenantId: string | undefined): string =>
  tenantId ? `${path}?${CLIENT_PARAM}=${encodeURIComponent(tenantId)}` : path;

/**
 * A client user on a URL carrying another account's `?client=` — House's or another
 * client's — is sent home rather than shown their own page under it (NPJB-894). Nothing is
 * decided until the user is known: `isInternal` reads false before then.
 */
export const isForeignClient = (
  client: string | null,
  user: { tenantId: string } | null,
  isInternal: boolean,
): boolean => user !== null && !isInternal && !!client && client !== user.tenantId;
